import { Box, styled } from '@mui/material';

export const Chip = styled(Box)(({ theme }) => ({
    color: theme.palette.common.white,
    padding: '2px 4px',
    margin: 8,
    borderRadius: 4,
    fontSize: 12,
    verticalAlign: 'middle',
}));
